<template>
    <div class="box" style="display:flex">
        <el-card class="box-card" shadow="hover" v-if="dataSource.woa">
            <div class="content">
                <a class="result" target="_blank" :href="'/resource/woa?_mode=es&q='+this.keyword"><img src="https://static.711.cn/material/icon/v4/woa.png" />找到相关媒体<span class="number">{{dataSource.woa}}</span>条</a>
                <a type="text link" target="_blank" :href="'/resource/woa?_mode=es&q='+this.keyword"><i class="iconfont icon-right" ></i></a>
            </div>
        </el-card>

        <el-card class="box-card" shadow="hover" v-if="dataSource.weibo">
            <div class="content">
                <a class="result" target="_blank" :href="'/resource/weibo?_mode=es&q='+this.keyword"><img src="https://static.711.cn/material/icon/v4/weibo.png" />找到相关媒体<span class="number">{{dataSource.weibo}}</span>条</a>
                <a type="text link" target="_blank" :href="'/resource/weibo?_mode=es&q='+this.keyword"><i class="iconfont icon-right" ></i></a>
            </div>
        </el-card>

        <el-card class="box-card" shadow="hover" v-if="dataSource.xhs">
            <div class="content">
                <a class="result" target="_blank" :href="'/resource/xhs?_mode=es&q='+this.keyword"><img src="https://static.711.cn/material/icon/v4/xhs.png" />找到相关媒体<span class="number">{{dataSource.xhs}}</span>条</a>
                <a type="text link" target="_blank" :href="'/resource/xhs?_mode=es&q='+this.keyword"><i class="iconfont icon-right" ></i></a>
            </div>
        </el-card>

        <el-card class="box-card" shadow="hover" v-if="dataSource.live">
            <div class="content">
                <a class="result" target="_blank" :href="'/resource/live?_mode=es&q='+this.keyword"><img src="https://static.711.cn/material/icon/v4/live.png" />找到相关媒体<span class="number">{{dataSource.live}}</span>条</a>
                <a type="text link" target="_blank" :href="'/resource/live?_mode=es&q='+this.keyword"><i class="iconfont icon-right" ></i></a>
            </div>
        </el-card>

        <el-card class="box-card" shadow="hover" v-if="dataSource.video">
            <div class="content">
                <a class="result" target="_blank" :href="'/resource/video?_mode=es&q='+this.keyword"><img src="https://static.711.cn/material/icon/v4/video.png" />找到相关媒体<span class="number">{{dataSource.video}}</span>条</a>
                <a type="text link" target="_blank" :href="'/resource/video?_mode=es&q='+this.keyword"><i class="iconfont icon-right" ></i></a>
            </div>
        </el-card>
        
    </div>
    
</template>
<script>
export default{
    props:["keyword","taxonomies"],
    data(){
        return {
            pageUrl:'/resource/result_count',
            loading:false,
            dataSource:{
                woa:0,
                weibo:0,
                live:0,
                video:0,
                xhs:0
            }
        }
    },
    watch:{
        $route(){
            this.load()
        }
    },
    created(){
        this.load()
    },
    methods:{
        clear(){
            this.dataSource = {
                woa:0,
                weibo:0,
                live:0,
                video:0,
                xhs:0
            }
        },
        load(){
            this.clear();

            this.taxonomies.map(v=>{
                this.loading = true;
                this.$http
                .get(this.pageUrl+`?taxonomy=${v}&q=${this.keyword}`)
                .then(response => {
                    if (response.success) {
                        this.dataSource[v] = response.data;
                    }
                })
                .catch()
                .then(() => {
                    this.loading = false;
                });
            })
            
        }
    }
}
</script>
<style scoped lang="scss">
    @import './../../../config.scss';
    .box.box-card:last-child{
        margin-right:0;
    }
    .box-card{
        width:250px;
        font-size:14px;
        margin-right:12px;
        .content{
            display:flex;justify-content:space-between;align-items:center;
            .result{
                display:flex;align-items:center;
                img{
                    width:25px;
                    height:25px;
                    margin-right:8px;
                    box-shadow: 0 0 5px #dbdbdb;
                    border-radius: 50%;
                }
                .number {
                    color: $--color-primary;
                }
            }
            i{
                font-size: 20px;
            }
        }
    }
    
    
   
</style>


// WEBPACK FOOTER //
// src/components/_widget/ResultCount.vue